import {
  BusinessStatusType,
  ProfilePermissionType,
  PropertyTypeCode,
  RegistryCode,
  RegistryItemStatusCodeType,
  ZoneCodeType,
} from '@/api/backend/types';
import { CountryCode, getCountries, getCountryCallingCode, isSupportedCountry } from 'libphonenumber-js';
import { CountryIso2MobileCode } from './types';

export const COUNTRY_MOBILE_CODES: CountryIso2MobileCode[] = getCountries()
  .filter((countryCode) => isSupportedCountry(countryCode))
  .filter((countryCode) => countryCode !== 'IL') // Remove Israel
  .map((countryCode) => ({
    mobileCode: `+${getCountryCallingCode(countryCode as CountryCode)}`,
    countryIso2: countryCode,
  }))
  .sort((a, b) => a.mobileCode.localeCompare(b.mobileCode));

export const PROFILE_PERMISSION: Record<ProfilePermissionType, ProfilePermissionType> = {
  PMS_CONTRACT: 'PMS_CONTRACT',
  PMS_PAY: 'PMS_PAY',
  PMS_PERMIT: 'PMS_PERMIT',
  PMS_READ: 'PMS_READ',
  PMS_REPRESENTATIVES: 'PMS_REPRESENTATIVES',
};

export const REGISTRY_STATUSES: RegistryItemStatusCodeType[] = [
  'ACTIVE',
  'PENDING',
  'EXPIRED',
  'SUSPENDED',
  'COMPLETED',
  'CANCELED',
];

export const PROCESS_BUSINESS_STATUSES: BusinessStatusType[] = [
  'draft',
  'processing',
  'completed',
  'rejected',
  'pendingChanges',
  'pendingPayment',
  'canceled',
];

export const PROPERTY_TYPE_CODES: PropertyTypeCode[] = [
  'PRP_LOGISTICS',
  'PRP_COMMERCIAL',
  'PRP_INDUSTRIAL',
  'PRP_TOURISM',
  'PRP_RESIDENTIAL_COMMERCIAL',
];

export const ZONE_CODES: ZoneCodeType[] = [
  'SOH',
  'SLH',
  'SEZ',
  'MIA',
  'EZD',
  'KHZ',
  'MAZ',
  'SIC',
  'KOM',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  'RIC',
];

export enum Languages {
  EN = 'en',
  AR = 'ar',
}

export type OfficialSource = {
  name: string;
  url: string;
};

export const OFFICIAL_SOURCES: OfficialSource[] = [
  {
    name: 'Public Authority for Special Economic Zones and Free Zones',
    url: 'https://opaz.gov.om/en',
  },
  {
    name: 'Oman Business Platform',
    url: 'https://www.business.gov.om/ieasy/wp/en/',
  },
  { name: 'Sohar Free Zone', url: 'https://soharportandfreezone.om/' },
  { name: 'MADAYN', url: 'https://madayn.om/en/pages/home.aspx' },
  { name: 'Khazaen Economic City', url: 'https://khazaen.om/' },
  { name: 'Special Economic Zone at Duqm', url: 'https://duqm.gov.om/' },
  { name: 'Salalah Free Zone', url: 'https://www.sfzco.com/' },
  { name: 'Al Mazunah Free Zone', url: 'https://madayn.om/sites/AFZ/EN/Pages/home.aspx' },
];

export const REGISTRY_CODE: Record<RegistryCode, RegistryCode> = {
  REG_LUCR: 'REG_LUCR',
  REG_REC: 'REG_REC',
};
